import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

function PlaceholderShell({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center p-8 font-[family-name:var(--font-outfit)]">
      <div className="max-w-md rounded-xl border border-gray-200/90 bg-white px-8 py-10 text-center shadow-sm">
        <h1 className="text-xl font-semibold tracking-tight text-gray-900">{title}</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-600">{description}</p>
        {children}
      </div>
    </div>
  );
}

export function EpcProcurementPlaceholder() {
  return (
    <PlaceholderShell
      title="EPC procurement"
      description="Procurement views for EPC projects will appear here. This area is reserved for upcoming purchasing and vendor workflows."
    />
  );
}

export function EpcEngineeringPlaceholder() {
  return (
    <PlaceholderShell
      title="EPC engineering"
      description="Engineering documentation and workflows for EPC projects will appear here. This screen is a placeholder until those features ship."
    >
      <div className="mt-6">
        <Link
          to="/demo/wind-farm"
          className="inline-flex rounded-lg bg-teal-700 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-800"
        >
          Open wind farm 3D demo
        </Link>
        <p className="mt-2 text-xs text-gray-500">Standalone Three.js wind farm scene (full screen, not tied to project data).</p>
      </div>
    </PlaceholderShell>
  );
}
